import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Button, FormControl, Grid, IconButton, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
import { RiDeleteBinLine } from 'react-icons/ri';
import { LanguageContext } from '../../../../../../../libs/Context';
import NewDialogPopup from '../../../../../../../components/Common/NewDialogPopup/NewDialogPopup';
import { Add } from '@mui/icons-material';
import AddOptions from './Options';
import { toast } from 'react-toastify';
import useDebounce from '../../../../../../../components/Hooks/useDebounce';

const CreateQuestions = (props) =>
{
	const { question, index, setQuestionD,
		handleDeleteQuestion, showDelete, editId, title } = props;
	const { language } = useContext(LanguageContext);
	const [ delQue, setDelQue ] = useState<boolean>(false);
	const [ qustnDetail, setQustnDetail ] = useState<any>(question);
	const debounceQuestionDetails = useDebounce(qustnDetail, 1000);

	const updateState = useCallback(() =>
	{
		setQuestionD((prevQue) =>
		{
			const updateQue = [ ...prevQue ];

			updateQue[index] = { ...qustnDetail };

			return updateQue;
		});
	}, [ debounceQuestionDetails ]);

	useEffect(() =>
	{
		updateState();
	}, [ debounceQuestionDetails ]);

	const handleChange = (e, type) =>
	{
		const updteObj = { ...qustnDetail };

		if (type === 'que') updteObj.question = e?.target?.value.replace(/^\s+/, '');
		if (type === 'ans')
		{
			updteObj.questionType = e?.target?.value;
			updteObj.options = [];
			if ([ 'singleChoice', 'multipleChoice' ]?.includes(e?.target?.value))
			{
				const newOption = '';

				updteObj.options.push(newOption);
			}
		}

		setQustnDetail(updteObj);
	};

	// for single and multiple choice questions
	const handleUpdateOptions = (ind, val, type?) =>
	{
		const newOptions = [ ...qustnDetail.options ];

		if (type === 'delete')
		{
			newOptions.splice(ind, 1);
		}
		else
		{
			newOptions[ind] = val;
		}
		setQustnDetail({ ...qustnDetail, options: newOptions });
	};

	const handleAddNewOptions = () =>
	{
		const updteQue = { ...qustnDetail };

		const isAnyOptionEmpty = updteQue?.options.some((item) => item?.trim() === '');

		if (isAnyOptionEmpty)
		{
			toast.error(language?.fillAllOptions, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
		}
		else
		{
			const newOption = '';

			updteQue.options.push(newOption);
			setQustnDetail(updteQue);
		}
	};

	const handleDelete = () =>
	{
		handleDeleteQuestion(index);
		setDelQue(false);
	};

	return (
		<>
			<Grid container sx={{ padding: '12px 16px', margin: '8px 0', border: '1px solid #CFD1D4', borderRadius: 'var(--pixel8)' }} >
				<Grid item sm={12}>
					<Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
						<Typography fontWeight='var(--font500)'>{index + 1}. {language.question}</Typography>
						{showDelete &&
						<IconButton onClick={() => setDelQue(true)}>
							<RiDeleteBinLine fontSize='var(--pixel20)'/>
						</IconButton>}
					</Stack>
				</Grid>
				<Grid item pb='var(--pixel16)' sm={12}>
					<TextField
						fullWidth
						autoFocus={title?.trim() !== '' && (qustnDetail?.question === '' || editId === qustnDetail?.questionId)}
						variant='standard'
						label={language.enterUrQuestion}
						value={qustnDetail?.question}
						onChange={(e) => handleChange(e, 'que')}
					/>
				</Grid>
				<Grid item py='var(--pixel8)' sm={12}>
					<FormControl variant='standard' fullWidth>
						<Select
							labelId={`demo-simple-select-standard-label-${index}`}
							id={`demo-simple-select-standard-${index}`}
							value={qustnDetail?.questionType}
							onChange={(e) => handleChange(e, 'ans')}
							label={language?.answer}
						>
							<MenuItem value='short'>{language.shortAnswer}</MenuItem>
							<MenuItem value='singleChoice'>{language.single}</MenuItem>
							<MenuItem value='multipleChoice'>{language.multiple}</MenuItem>
							<MenuItem value='star'>{language.starRating}</MenuItem>
						</Select>
					</FormControl>
					{[ 'singleChoice', 'multipleChoice' ]?.includes(qustnDetail?.questionType) &&
					(
						<>
							<Grid item pt='var(--pixel8)'>
								<Typography fontWeight='var(--font400)'>{language?.options}</Typography>
							</Grid>
							{qustnDetail?.options?.map((eachOptn, ind) =>
								(
									<AddOptions
										key={ind}
										index={ind}
										eachOptn={eachOptn}
										handleUpdate={handleUpdateOptions}
										options={qustnDetail?.options}
									/>
								)
							)}
							<Grid item xs={12} >
								<Stack direction='row' width='var(--percent100)' pt='var(--pixel16)' justifyContent={'flex-end'}>
									<Button variant='outlined' sx={{ textTransform: 'capitalize' }}
										onClick={handleAddNewOptions}
										disabled={qustnDetail?.options?.some((item) => item?.trim() === '')}
									>
										<Add color='primary'/>&nbsp;{language.add}</Button>
								</Stack>
							</Grid>
						</>
					)}

				</Grid>
			</Grid>
			{delQue &&
			<NewDialogPopup
				open={delQue}
				handleConfirm={() => setDelQue(false)}
				closeCallBack={handleDelete}
				type={language?.no}
				id={undefined}
				label={language?.confirmDeleteQuestions}
				from='feedCreate'
				formatType={language.yes}
			/>
			}
		</>

	);
};

export default CreateQuestions;
